// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HOgkx","footer":"styles_footer__3PAdB"};